export default "__VITE_ASSET__CY1Cywg5__"